export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.summercruise.com.my",
    backendUrl: "http://localhost:3100",
    agentBackendUrl: "http://localhost:4041",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.summercruise.com.my";
    exportResult.backendUrl = "https://sg-api.summercruise.com.my/admin";
    exportResult.agentBackendUrl =
      "https://sg-api.summercruise.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://sg-api.summercruise.com.my/app";
    exportResult.jsReportUrl = "https://sg-report.summercruise.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.agentBackendUrl = "https://business-api.travoxis.com";
    exportResult.userPortalBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://sg-report.summercruise.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.summercruise.com.my";
    exportResult.backendUrl = "https://api.summercruise.com.my/admin";
    exportResult.agentBackendUrl =
      "https://api.summercruise.com.my/business";
    exportResult.userPortalBackendUrl =
      "https://api.summercruise.com.my/app";
    exportResult.jsReportUrl = "https://report.summercruise.com.my";
  }
  return exportResult;
};
